/* eslint-disable camelcase */

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Verifiez nos documents.`,
    documentation: `Documentation`,
    contact_us: `Contactez-nous`,
    starleader_values: `Valeurs de StarLeader`,
    update_your_cookies_settings: `Mettre à jour vos paramètres de cookies`,
    cookiePolicy: `Cookies`,
    legalNotice: `Mentions légales`,
    privacyPolicy: `Confidentialité`,
  },
  menu: {
    Home: `Accueil`,
    Summary: `Résumé`,
    Reviews: `Avis`,
    Goals: `Objectifs`,
    Campaigns: `Campagnes`,
    Analytics: `Analytique`,
    Company: `Entreprise`,
    Admin: `Administration`,
  },
  home_page: {
    no_reviews_yet: `Pas encore d'avis. Demandez à vos employés de vous évaluer.`,
    step_1: `Manager Auto-avis, Employé/Peer avis .`,
    step_2: `Définir un objectif et 3 actions par le manager après discussion avec le N+1 et l'équipe, idéalement`,
    step_3: `Avis sur la progression de l'objectif`,
    step_4: `Fin de la campagne`,
    welcome_msg: `Bonjour`,
    welcome_text: `Nous sommes là pour vous soutenir à chaque étape. Faisons de ce voyage un succès ensemble !`,
    campaign_step: `Guide de campagne étape par étape`,
    no_campaign: `Aucune campagne disponible. Contactez votre service RH pour en créer une et commencer les évaluations!`,
    click_here: `Cliquez ici`,
    create_one: `pour en créer une.`,
    hr_home_page_intro_1: `Rien a faire ici, Visiter`,
    hr_home_page_intro_2: `la page Analytiques`,
    hr_home_page_intro_3: `pour voir les statistiques, ou`,
    hr_home_page_intro_4: `la page Campagnes`,
    hr_home_page_intro_5: `pour voir les détails de la campagne en cours`,
    ai_enabled: `IA activée`,
    ai_disabled: `IA désactivée`,
    direct_reports: `N-1`,
    reports_to: `Rapporte à`,
    no_manager: `Pas de manager`,
  },
  reviews_page: {
    no_self_reviews_yet: `Aucun auto-avis n'a encore été complété.`,
    no_reviews_yet: `Aucun avis n'a encore été complété.`,
    no_reviews_visible: `Vos avis seront visible à la fin de la campagne étape avis`,
    my_reviews: `Mes avis`,
    self_reviews: `Auto-avis`,
    submitted_reviews: `Avis soumis`,
    from_total_reviews: `Sur total des avis`,
    campaign: `Campagne`,
    days_till_end: `jours restants`,
    day_till_end: `jour restant`,
    completed: `Terminé`,
    ending_soon: `Se termine bientôt`,
    active: `Actif`,
    in_progress: `En cours`,
    days_total: `jours au total`,
    day_total: `jour au total`,
    campaign_timeline: `Chronologie de la campagne`,
    start: `Début`,
    end: `Fin`,
    current_status: `Statut actuel`,
    days_elapsed: `Jours écoulés`,
    total_duration: `Durée totale`,
  },
  survey_summary: {
    self_review: `Auto-avis`,
    review: `Avis`,
    peer_review: `Peer-Avis`,
    manager_review: `Manager-Avis`,
    progress_goal_survey: `Goal-Avis`,
    recommendation: `Recommendation`,
    trust: `Confiance`,
    open_review: `ouvrir`,
    resume_review: `reprendre`,
  },
  categories_tooltip: {
    care: `VISION: envisions a desired future and generates excitement by conveying a compelling, shared vision`,
    coach: `COMMUNICATION: communicates well and frequently provides explanations to stakeholders`,
    develop: `DEVELOPMENT: fosters a development culture by encouraging all team members to embrace a growth mindset and taking actions daily to develop themselves and those around them`,
    deliver: `TRUST: influences others by building credibility and positive relationships rather than relying on authority to generate momentum around Shape priorities`,
    lead: `PROBLEM SOLVING: continuous improvement and the use of proven, problem-solving methodologies`,
  },
  reviews_one_pager: {
    manager_reaction: `réaction de votre manager:`,
    peer_reaction: `réaction de votre collègue:`,
    comment: `commentaire:`,
    peer_comment: `peer report commentaires:`,
    manager_comment: `direct report commentaires:`,
  },
  survey: {
    comment_label: `Ajouter votre commentaire (Obligatoire)`,
    comment_tooltip: `Veuillez être constructif et respectueux. Tout contenu raciste, sexiste, discriminatoire ou offensant sera supprimé. Utilisez un langage le plus neutre possible pour maintenir l'anonymat. Suite à la notification d'une tierce partie, nous pourrions retirer tout contenu inapproprié.`,
    reminder_question_label: `Question`,
    submit: `Soumettre`,
    start_survey: `Salut! Il vous faudra maximum 10 minutes pour compléter cette campagne d'avis qui est anonyme.`,
    survey_end: `Félicitations pour votre participation ! Votre évaluation a été soumise. Jetons un œil au résumé.`,
    rating1: `Oups, il semble que votre manager ait des améliorations à apporter dans ce comportement... Quelle action recommanderiez-vous à votre manager pour s'améliorer ?`,
    rating5: `Wow ! Il semble que votre manager excelle dans ce comportement. Ce serait bien de le faire savoir à votre manager en fournissant un exemple concret. Cela sera sûrement apprécié !`,
    click_icon_bellow: `Cliquez sur l'icône ci-dessous pour continuer`,
    click_star: `Cliquez sur une étoile pour continuer`,
    add_comment: `Ajoutez votre commentaire ici (Optionnel, sauf pour les notes de 1 et 5 étoiles)`,
    add_comment_progress_goal: `Ajoutez votre commentaire ici (Optionnel)`,
    submitted: `Merci ! Votre avis a été soumis avec succès`,
    progress_goal: `Pensez-vous que ce leader s'est amélioré sur ce comportement?`,
    goal_review_title: `Examen de l'Objectif`,
    peer: `Pair`,
    manager: `Manager`,
    could_not_save_answer: `Impossible de sauvegarder la réponse. Veuillez réessayer.`,
    please_answer_all_questions: `Veuillez répondre à toutes les questions avant de soumettre.`,
    submit_failed: `Échec de la soumission. Veuillez réessayer.`,
    error_id_missing: `Erreur : SurveyWizard : Patch SurveyResult : ID manquant`,
    you_are_reviewing: `Vous évaluez :`,
  },
  ai: {
    checking: `Vérification du commentaire…`,
    ok_chip: `Clair et constructif`,
    unavailable: `L'IA n'est pas disponible pour le moment`,
    flagged_hint: `Veuillez revoir ce commentaire — une version plus claire est proposée ci-dessous.`,
    flagged_hint_anonymity: `Veuillez revoir ce commentaire — une version plus claire est proposée ci-dessous.`,
    flagged_hint_quality: `Veuillez revoir ce commentaire — une version plus claire est proposée ci-dessous.`,
    accept_proposal: `Utiliser`,
    accept_proposal_quality: `Utiliser`,
    flag_proposal: `Signaler`,
    proposed_label: `Version plus sûre suggérée`,
    proposed_label_quality: `Version plus claire suggérée`,
    submit_warn_title: `Veuillez revoir votre commentaire`,
    submit_warn_body: `L'IA a suggéré des améliorations à votre brouillon. Vous pouvez revenir modifier, ou continuer quand même.`,
    submit_warn_continue: `Continuer quand même`,
    submit_warn_edit: `Continuer à modifier`,
    reason_timeout: `délai dépassé`,
    reason_network: `réseau`,
    reason_provider_error: `erreur fournisseur`,
    reason_rate_limit: `limite de débit`,
    reason_user_budget: `budget utilisateur`,
    reason_platform_budget: `budget plateforme`,
    reason_workspace_budget: `budget espace de travail`,
    campaign_summary_title: `Résumé IA de campagne`,
    campaign_summary_loading: `Chargement du résumé…`,
    campaign_summary_generating: `Génération de votre résumé IA pour cette campagne…`,
    campaign_summary_locked: `Le résumé IA se débloque une fois l'étape d'avis terminée et les prochaines étapes activées.`,
    campaign_summary_not_allowed: `L'assistance IA n'est pas activée pour votre compte.`,
    campaign_summary_unavailable: `Le résumé IA n'est pas disponible pour le moment. Réessayez plus tard.`,
    campaign_summary_disagree: `Pas d'accord`,
    campaign_summary_disagreed: `Désaccord enregistré`,
    campaign_summary_disagreed_thanks: `Merci — votre désaccord a été enregistré pour l'équipe plateforme.`,
    campaign_summary_disagree_error: `Impossible d'enregistrer le désaccord.`,
    campaign_summary_strengths: `Points forts`,
    campaign_summary_improvements: `Axes d'amélioration`,
    campaign_summary_clarifications: `Points à clarifier`,
    campaign_summary_next_steps: `Prochaines étapes suggérées`,
    campaign_summary_direction: `Direction globale`,
    campaign_summary_action: `Action`,
    campaign_summary_cached: `Affichage de votre résumé enregistré pour cette campagne (non régénéré).`,
    campaign_summary_regenerated: `Résumé mis à jour à partir des nouveaux avis de cette campagne.`,
    campaign_summary_ai_badge: `Généré par l'IA`,
    campaign_summary_ai_subtitle: `Insights construits à partir des avis, notes, commentaires et discussions de votre campagne.`,
    campaign_summary_visual_overview: `Aperçu de campagne`,
    campaign_summary_categories: `Catégories`,
    campaign_summary_radar_title: `Vous vs autres managers`,
    campaign_summary_focus_chip: `Priorité`,
    campaign_summary_focus_hint: `Scores les plus bas à prioriser : {categories}`,
    campaign_summary_vs_peers_ahead: `+{n}`,
    campaign_summary_vs_peers_behind: `-{n}`,
    campaign_summary_vs_peers_even: `0.0`,
    campaign_summary_vs_peers_tooltip: `vs autres managers`,
    campaign_summary_category_rating_tooltip: `votre note de catégorie`,
    campaign_summary_show_more: `Voir plus`,
    campaign_summary_show_less: `Voir moins`,
  },
  discuss_chat: {
    discuss: `Discuter`,
    chat_tooltip: `Ouvrez la fenêtre de discussion. Si un nouveau message est reçu, une notification sera envoyée.`,
    chat_label: `Ajouter votre message...`,
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  product: `produit`,
  invoice: `facture`,
  details: `détail`,
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `niveau menu`,
  menu_level_2a: `niveau menu 2a`,
  menu_level_2b: `niveau menu 2b`,
  menu_level_3a: `niveau menu 3a`,
  menu_level_3b: `niveau menu 3b`,
  menu_level_4a: `niveau menu 4a`,
  menu_level_4b: `niveau menu 4b`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  item_external_link: `lien externe de l'article`,
  description: `la description`,
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  reviews: `avis`,
  review: `avis`,
  self_review: `auto-avis par rapport à votre équipe`,
  campaign: `campagne`,
  me: `Moi`,
  other_managers: `Autres managers`,
  recommend_you: `Vous recommandent`,
  trust_you: `Vous font confiance`,
  goalProgressApprovalPercentage: `Approbation de votre objectif`,
  employee: `collaborateur`,
  manager: `manager`,
  hr: `RH`,
  summary: `Résumé`,
  rating_answer: `réponses d'avis`,
  from_your_team: `de votre équipe`,
  from_your_peers: `de vos peers`,
  comparaison: `comparaison`,
  no_results_yet: `Pas de résultats.`,
  campaign_page: {
    campaign: `Campagne`,
    set_goal: `Fixer un objectif`,
    review_period: `Période d'avis`,
    one_campaign: `Il y a déjà une campagne en cours. Une seule campagne peut être active à la fois.`,
    no_campaign: `Il n'y a actuellement aucune campagne.`,
    create_campaign: `Créer une nouvelle campagne`,
    start_campaign: `Démarrer`,
    edit_campaign_dates: `Modifier les Dates`,
    edit_step_dates: `Modifier les Dates d'Étape`,
    campaign_period: `Période de Campagne`,
    save_changes: `Enregistrer`,
    cancel: `Annuler`,
    create_new_campaign: `Créer une Campagne`,
    select_start_date: `Sélectionnez une date de début. Le système créera automatiquement les dates par défaut.`,
    campaign_start_date: `Date de Début`,
    please_select_date: `Veuillez sélectionner une date`,
    campaign_overlap_error: `Impossible de créer une campagne qui chevauche avec une période existante`,
    access_denied: `Accès Refusé`,
    hr_admin_only: `Cette page n'est accessible qu'aux utilisateurs RH et Admin.`,
    campaign_overview_tooltip: `Aperçu de la campagne - Vous pouvez modifier toutes les dates des étapes de campagne actuelles`,
    validation_select_dates: `Veuillez sélectionner les dates de début et de fin`,
    validation_start_after_end: `La date de début ne peut pas être après la date de fin`,
    validation_step_before_campaign_start: `La date de début de l'étape ne peut pas être avant la date de début de la campagne. Veuillez d'abord mettre à jour la période de campagne.`,
    validation_step_after_campaign_end: `La date de fin de l'étape ne peut pas être après la date de fin de la campagne. Veuillez d'abord mettre à jour la période de campagne.`,
    all_campaigns: `Toutes les Campagnes`,
    expand: `Développer`,
    collapse: `Réduire`,
    campaign_name: `Campagne {number}`,
  },
  values_page: {
    title: `La confiance se gagne en gouttes et se perd en litres`,
    author: `Jean-Paul Satre`,
    section1: `La relation entre le manager et le collaborateur est clé dans notre vie professionnelle. Que vous soyez employé ou manager, il est dans l'intérêt de chacun de placer la qualité de cette relation au cœur de nos interactions quotidiennes.`,
    section2: `En tant que collaborateur, StarLeader vous donne l'opportunité de vous exprimer anonymement et de manière constructive sur le comportement de votre manager. Votre opinion compte!`,
    section3: `Devenez un agent de changement en aidant votre manager à devenir une meilleure version de lui-même, c'est l'expérience unique que nous vous proposons avec StarLeader.`,
    section4: `En tant que manager, StarLeader est un outil pour améliorer votre conscience de soi, progresser et développer la confiance au sein de votre équipe! Devenez un meilleur StarLeader et donnez-vous plus de chances de grandir au sein de l'entreprise, c'est l'expérience unique que nous vous offrons avec StarLeader.`,
    section5: `En faisant de la qualité du leadership un nouvel indicateur de succès, StarLeader vise à combiner performance durable et bien-être de l'équipe.`,
  },
  continue: `Continuer`,
  privacy_page: {
    title: `Politique de Confidentialité`,
    section1: `Chez StarLeader, protéger votre vie privée est une priorité.`,
    section2: `Lorsque vous utilisez le site www.starleader.io (le "Site"), nous pouvons collecter des données personnelles vous concernant.`,
    section3: `Le but de cette politique est de vous informer sur la manière dont nous traitons ces données en conformité avec le Règlement (UE) 2016/679 du 27 avril 2016 sur la protection des personnes physiques à l'égard du traitement des données personnelles et à la libre circulation de ces données (le "RGPD").`,
    section4: `1. Qui est le responsable du traitement des données?`,
    section5: `Lorsque vous naviguez sur notre Site, le responsable du traitement des données est Alphayz, une société S.A.S enregistrée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 952 853 109 et dont le siège social est situé au 33 rue Benoit Malon 92800 Puteaux ("Nous").`,
    section6: `En revanche, lorsque nos clients utilisent nos services, nous collectons et traitons des données personnelles pour leur compte. Nos clients sont donc responsables du traitement des données conformément à l'article 4 du RGPD. Nous agissons en tant que sous-traitant, en tant que prestataire de services.`,
    section7: `2. Quelles données collectons-nous?`,
    section8: `Les données personnelles sont des données qui peuvent être utilisées pour identifier une personne directement ou par recoupement avec d'autres données.`,
    section9: `Nous collectons des données personnelles dans les catégories suivantes:`,
    section10: `Données d'identification `,
    section11: `(nom, prénom, adresse e-mail professionnelle);`,
    section12: `Données relatives à votre vie professionnelle `,
    section13: `(nom de l'entreprise, poste/fonction);`,
    section14: `Données de connexion `,
    section15: `(logs de connexion, mots de passe chiffrés);`,
    section16: `Données de navigation `,
    section17: `(adresse IP, pages vues, date et heure de connexion, navigateur utilisé, système d'exploitation, identifiant utilisateur, IFA);`,
    section18: `Données de localisation.`,
    section19: `3. Sur quelles bases légales, à quelles fins et pendant combien de temps conservons-nous vos données personnelles?`,
    section20: `Objectifs`,
    section21: `Base légale`,
    section22: `Durée de conservation`,
    section23: `Fournir nos services disponibles sur notre Site`,
    section24: `Exécution de mesures précontractuelles prises à votre demande et/ou exécution du contrat que vous ou votre entreprise avez signé avec Nous`,
    section25: `Lorsque vous avez créé un compte: vos données sont conservées pendant la durée de votre compte. Vos logs de connexion sont conservés pendant un (1) an. Si votre compte est inactif pendant 2 ans, vos données personnelles seront supprimées si vous ne répondez pas à notre e-mail de réactivation`,
    section26: `Améliorer nos services`,
    section27: `Notre intérêt légitime à améliorer nos services`,
    section28: `Les données personnelles sont conservées pendant un (1) an`,
    section29: `Envoyer des newsletters, des sollicitations et des messages promotionnels`,
    section30: `Pour les clients: notre intérêt légitime à fidéliser nos clients et à les tenir informés de nos dernières actualités Pour les prospects: votre consentement`,
    section31: `Les données sont conservées pendant 3 ans à partir de votre dernier contact avec Nous`,
    section32: `Répondre à vos demandes d'information`,
    section33: `Notre intérêt légitime à répondre à vos demandes`,
    section34: `Les données sont conservées le temps nécessaire pour traiter votre demande d'information et sont supprimées une fois la demande traitée`,
    section35: `Établir des statistiques (de navigation, d'audience du Site, etc.) et améliorer les fonctionnalités du Site par le dépôt de cookies de mesure d'audience`,
    section36: `Notre intérêt légitime à analyser la composition de notre clientèle et à améliorer nos services`,
    section37: `Les données sont conservées pendant vingt-cinq (25) mois`,
    section38: `Gérer les demandes d'exercice de droits`,
    section39: `Notre intérêt légitime à répondre à vos demandes et à en conserver une trace`,
    section40: `Si nous vous demandons une preuve d'identité, nous ne la conserverons que le temps nécessaire pour vérifier votre identité. Une fois la vérification terminée, la preuve d'identité est supprimée.`,
    section41: `4. Qui sont les destinataires de vos données?`,
    section42: `Auront accès à vos données personnelles:`,
    section43: `Le personnel de notre société;`,
    section44: `Nos sous-traitants: hébergeur, fournisseur de mesure et d'analyse d'audience, fournisseur de services e-mail;`,
    section45: `Le cas échéant: organismes publics et privés, exclusivement pour répondre à nos obligations légales;`,
    section46: `5. Vos données seront-elles transférées hors de l'Union Européenne?`,
    section47: `Vos données sont conservées et stockées pendant la durée du traitement sur les serveurs de la société Heroku, situés dans l'Union Européenne.`,
    section48: `6. Quels sont vos droits sur vos données?`,
    section49: `Vous disposez des droits suivants sur vos données personnelles:`,
    section50: `Droit à l'information: `,
    section51: `c'est précisément la raison pour laquelle nous avons rédigé cette politique. Ce droit est prévu aux articles 13 et 14 du RGPD.`,
    section52: `Droit d'accès: `,
    section53: `vous avez le droit d'accéder à toutes vos données personnelles à tout moment, conformément à l'article 15 du RGPD.`,
    section54: `Droit de rectification: `,
    section55: `vous avez le droit de rectifier à tout moment vos données personnelles inexactes, incomplètes ou obsolètes conformément à l'article 16 du RGPD.`,
    section56: `Droit à la limitation: `,
    section57: `vous avez le droit d'obtenir la limitation du traitement de vos données personnelles dans certains cas définis à l'article 18 du RGPD.`,
    section58: `Droit à l'effacement: `,
    section59: `vous avez le droit de demander l'effacement de vos données personnelles, et d'interdire la collecte future de vos données personnelles pour les motifs énoncés à l'article 17 du RGPD.`,
    section60: `Droit d'introduire une réclamation auprès d'une autorité de contrôle compétente `,
    section61: `(en France, la CNIL), si vous estimez que le traitement de vos données personnelles constitue une violation des textes applicables, conformément à l'article 77 du RGPD`,
    section62: `Le droit de définir des directives relatives à la conservation, à l'effacement et à la communication de vos données personnelles après votre décès.`,
    section63: `Droit de retirer votre consentement à tout moment: `,
    section64: `pour les finalités basées sur le consentement, l'article 7 du RGPD prévoit que vous pouvez retirer votre consentement à tout moment. Ce retrait n'affectera pas la licéité du traitement effectué avant le retrait.`,
    section65: `Droit à la portabilité: `,
    section66: `dans certaines conditions précisées à l'article 20 du RGPD, vous avez le droit de recevoir les données personnelles que vous nous avez fournies dans un format standard lisible par machine et de demander leur transfert au destinataire de votre choix.`,
    section67: `Droit d'opposition: `,
    section68: `en vertu de l'article 21 du RGPD, vous avez le droit de vous opposer au traitement de vos données personnelles. Notez toutefois que nous pouvons continuer à les traiter malgré cette opposition, pour des raisons légitimes ou pour la défense de droits légaux.`,
    section69: `Vous pouvez exercer ces droits en nous écrivant à l'adresse ci-dessous. Nous pouvons vous demander de fournir des informations ou des documents supplémentaires pour prouver votre identité.`,
    section70: `7. Quels cookies utilisons-nous?`,
    section71: `Pour en savoir plus sur la gestion des cookies, nous vous invitons à consulter notre`,
    section72: `8. Point de contact pour exercer vos droits`,
    section73: `Adresse e-mail de contact: support@starleader.io.`,
    section74: `Adresse de contact: 33 rue Benoit Malon 92800 Puteaux FRANCE.`,
    section75: `9. Modifications`,
    section76: `Nous pouvons modifier cette politique à tout moment, notamment pour nous conformer à toute évolution réglementaire, légale, éditoriale ou technique. Ces modifications s'appliqueront à compter de la date d'entrée en vigueur de la version modifiée. Vous êtes donc invités à consulter régulièrement la dernière version de cette politique. Néanmoins, nous vous tiendrons informés de toute modification importante de cette Politique de Confidentialité.`,
    section77: `Date d'effet: 6 juin 2023`,
  },
  cookies_page: {
    title: `Politique de Cookies`,
    section1: `1. Qu'est-ce qu'un Cookie?`,
    section2: `Lors de votre navigation sur le site www.starleader.io, des cookies, pixels et autres traceurs sont déposés sur votre navigateur.`,
    section3: `Un cookie est un petit fichier, souvent crypté, stocké dans votre navigateur ou votre terminal et identifié par un nom. Il est déposé lorsque vous visitez un site. Chaque fois que vous revenez sur le site en question, le cookie est récupéré depuis votre navigateur ou terminal. Ainsi, chaque fois que vous visitez le site, le navigateur est reconnu.`,
    section4: `2. Identification des Cookies`,
    section5: `Nous pouvons utiliser des cookies techniques et de mesure d'audience. Vous en serez informé lors de votre première visite sur le Site utilisant ces cookies. Vous serez alors invité à les accepter ou à les refuser de la manière décrite ci-dessous.`,
    section6: `Cookies techniques et fonctionnels`,
    section7: `Les cookies techniques et fonctionnels sont nécessaires au bon fonctionnement du Site et à la fourniture de nos services. Ils sont utilisés tout au long de votre navigation, afin de la faciliter et d'exécuter certaines fonctions.`,
    section8: `Un cookie technique peut, par exemple, être utilisé pour se souvenir de vos réponses à un formulaire ou de vos préférences en matière de langue ou de disposition du Site, lorsque de telles options sont disponibles.`,
    section9: `Cookies de mesure d'audience`,
    section10: `Ces cookies, également appelés "cookies analytiques", nous permettent de mesurer le nombre de visites, le nombre de pages vues et l'activité des utilisateurs. Ils peuvent collecter votre adresse IP jusqu'à la ville de connexion. Les cookies de mesure d'audience nous permettent de générer des statistiques sur le nombre de visites et la navigation de notre Site afin d'améliorer notre performance. Les cookies utilisés nous permettent également d'identifier les problèmes de navigation et éventuellement de les résoudre.`,
    section11: `3. Vos préférences en matière de cookies`,
    section12: `Les cookies pouvant être déposés sans consentement`,
    section13: `Certains cookies ne nécessitent pas votre consentement, tels que:`,
    section14: ` Les cookies techniques et fonctionnels qui sont nécessaires au fonctionnement du Site;`,
    section15: ` Certains cookies de mesure d'audience ou cookies qui nous permettent de tester différentes versions du Site dans le but d'optimiser les choix éditoriaux;`,
    section16: `Acceptation ou refus des Cookies soumis à votre consentement exprès`,
    section17: `Tous les autres cookies nécessitent votre consentement. Il s'agit des cookies publicitaires, des cookies de réseaux sociaux, des cookies de personnalisation de contenu et de certains cookies de mesure d'audience. Vous pouvez librement choisir d'accepter ou de refuser l'utilisation de ces cookies.`,
    section18: `Vous pouvez accepter ou refuser ces cookies lors de votre première visite sur le Site.`,
    section19: `Vos choix d'accepter ou de refuser les cookies seront conservés pour une période de six (6) mois.`,
    section20: `Vous êtes libre de retirer votre consentement et, plus généralement, de modifier vos préférences à tout moment, via le lien de la bannière de cookies.`,
    section21: `Paramétrage de votre navigateur`,
    section22: `Il est également possible de configurer votre navigateur pour accepter ou refuser certains cookies.`,
    section23: `Chaque navigateur propose des méthodes de configuration différentes.`,
  },
  legal_page: {
    title: `Mentions Légales`,
    section1: `Éditeur:`,
    section2: `Le site www.starleader.io est édité par:`,
    section3: `La société Alphayz`,
    section4: `S.A.S au capital social de 5.000,00 euros`,
    section5: `Immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 952 853 109`,
    section6: `Siège social: 33 rue Benoit Malon 92800 Puteaux FRANCE`,
    section7: `Numéro de TVA intracommunautaire: FR88952853109`,
    section8: `Numéro de téléphone: +33 6 64 44 59 06`,
    section9: `Adresse e-mail: support@starleader.io`,
    section10: `Directeur de la publication:`,
    section11: `Mme Laura Goddard, Présidente de la société Alphayz`,
    section12: `Hébergeur:`,
    section13: `Société: Salesforce Sarl (Heroku.Inc est une société Salesforce)`,
    section14: `Siège social: Route de la Longeraie 9, Morges, 1110, Suisse, à l'attention du Directeur, EMEA Sales Operations, avec une copie à l'attention du Service Juridique, 3 Avenue Octave Gréard, 75007 Paris, France.`,
    section15: `Les serveurs Heroku utilisés par starleader.io sont situés dans l'Union Européenne.`,
  },
  goals_page: {
    title: `Objectif`,
    target: `Date cible`,
    completed: `Terminé`,
    complete: `Terminer`,
    todo: `À faire`,
    inprogress: `En cours`,
    done: `Fait`,
    no_reviews: `Il n'y a pas encore d'avis soumis pour vous. Demandez à vos employés de remplir l'avis et revenez plus tard.`,
    no_reviews_1: `Il n'y a pas encore d'avis pour vous. Demandez à vos employés`,
    no_reviews_2: `de vous évaluer`,
    no_reviews_3: `et revenez plus tard. Les scores des avis sont importants pour un objectif constructif.`,
    one_goal: `Vous pouvez créer un seul objectif`,
    create_new_goal: `Créer un nouvel objectif`,
    set_score: `Score souhaité`,
    pick_rating: `Choisissez un score supérieur à l'actuel`,
    pick_score: `Choisissez un score supérieur à l'actuel`,
    achieve_improvement: `Délai d'amélioration`,
    one_month: `Un mois`,
    two_months: `Deux mois`,
    three_months: `Trois mois`,
    define_actions: `Définissez vos 3 actions:`,
    pick_action: `Choisissez une action à gauche ou saisissez-en une...`,
    chose_category: `Choisissez une catégorie dans laquelle vous souhaitez vous améliorer`,
    chose_behavior: `Choisissez le comportement que vous souhaitez améliorer`,
    category_selection_description: `Sélectionnez une catégorie pour créer votre objectif de développement et concentrer vos efforts d'amélioration.`,
    rating_label: `Note`,
    best_performance: `Meilleure Performance`,
    selected: `Sélectionné`,
    categories_ordered_note: `Les catégories sont classées par votre note de performance actuelle.`,
    behavior_selection_description: `Sélectionnez un comportement pour créer votre objectif de développement et concentrer vos efforts d'amélioration.`,
    behaviors_ordered_note: `Les comportements sont classés par votre note de performance actuelle.`,
    no_behaviors_available: `Aucun comportement disponible pour cette catégorie.`,
    configure_goal: `Configurez Votre Objectif`,
    configure_goal_description: `Définissez votre note cible et votre échéance pour compléter votre objectif de développement.`,
    current_rating: `Note Actuelle`,
    timeline_description: `Choisissez combien de temps vous voulez pour atteindre cette amélioration.`,
    configuration_note: `Sélectionnez une note cible supérieure à votre performance actuelle et une échéance réaliste.`,
    no_rating_options: `Aucune option de notation disponible`,
    campaign_ends_soon: `Campagne se termine bientôt`,
    actions_description: `Sélectionnez 3 actions pour vous aider à atteindre votre objectif. Vous pouvez choisir parmi les actions suggérées ou créer les vôtres.`,
    actions_progress: `Actions`,
    selected_actions: `Actions Sélectionnées`,
    action: `Action`,
    available_actions: `Actions Disponibles`,
    suggested: `Suggéré`,
    custom: `Personnalisé`,
    recommended: `Recommandé`,
    or_create_custom: `OU`,
    custom_action_placeholder: `Écrivez votre propre action pour vous aider à atteindre cet objectif...`,
    add_custom_action: `Ajouter Action Personnalisée`,
    create_goal: `Créer Objectif`,
    actions_note: `Vous pouvez modifier ou supprimer des actions jusqu'à ce que vous soumettiez. Une fois soumis, vous pouvez suivre vos progrès.`,
    pick_existing_actions: `Choisir Actions Existantes`,
    pick_existing_description: `Choisissez parmi nos actions suggérées pour vous aider à atteindre votre objectif.`,
    write_custom_actions: `Écrire Actions Personnalisées`,
    write_custom_description: `Créez vos propres actions personnalisées pour soutenir votre développement.`,
    no_actions_selected: `Aucune action sélectionnée pour le moment. Choisissez parmi les actions existantes ou écrivez les vôtres.`,
    progress: `Définir un objectif`,
    category: `Catégorie`,
    objective: `Objectif`,
    score: `Score`,
    timeline: `Délai`,
    actions: `Actions`,
    actions_complete: `Actions complétées`,
    status: `Statut`,
    ready_to_complete: `Prêt à Compléter`,
    in_progress: `En Cours`,
    complete_goal: `Compléter l'Objectif`,
    close_goal: `Fermer l'Objectif`,
    read_more: `Lire Plus`,
    edit: `Modifier`,
    received_reviews: `Avis reçus`,
    submitted_reviews: `Avis soumis`,
    peer_review: `Avis de collègue`,
    peer_reviews: `Avis de collègues`,
    manager_review: `Avis de manager`,
    manager_reviews: `Avis de managers`,
    self_review: `Auto-évaluation`,
    overall_progress: `Progrès Global`,
    completion_rate: `Taux de Réalisation`,
    total_reviews: `Total des Avis`,
    campaign_step_status: `Statut de l'Étape de Campagne`,
    campaign_dates: `Dates de Campagne`,
    remaining_days: `Jours Restants`,
    days_left: `jours restants`,
    overall_participation: `Participation Globale`,
    reviews_received: `avis reçus`,
    review_data_available_soon: `Les données d'avis seront disponibles lorsque 80% des avis attendus seront reçus ou 2 jours avant la fin de la campagne`,
    days_till_end: `jours jusqu'à la fin`,
    review_campaign_step: `étape de campagne d'avis`,
    campaign_timeline: `Chronologie de la Campagne`,
    start: `Début`,
    end: `Fin`,
    current_status: `Statut Actuel`,
    days_elapsed: `Jours Écoulés`,
    total_duration: `Durée Totale`,
    ending_soon: `Se Termine Bientôt`,
    active: `Actif`,
    campaign_completed: `Terminé`,
    days_total: `jours au total`,
    from_total_reviews: `Sur total des avis`,
  },
  ratingDescription: {
    1: `pas du tout d'accord`,
    2: `pas d'accord`,
    3: `ni d'accord, ni pas d'accord`,
    4: `d'accord`,
    5: `tout à fait d'accord`,
  },
  reactions: {
    1: `Merci`,
    2: `J'adore`,
    3: `Pas d'accord`,
  },
  tasks: {
    your_tasks: `Tâches Ouvertes`,
    select_feedback_team: `Sélectionner l'Équipe de Feedback`,
    select_feedback_team_description: `Choisissez qui donne des commentaires à vos collaborateurs directs.`,
    no_reviewers_selected: `Aucun évaluateur sélectionné pour le moment`,
    select_reviewers_description: `Cliquez sur le bouton "Sélectionner" pour choisir les évaluateurs pour les membres de votre équipe.`,
    select: `Sélectionner`,
    review_your_manager: `Évaluer Votre Manager`,
    review_your_manager_description: `Fournissez des commentaires ascendants à votre manager.`,
    review_your_peers: `Évaluer Vos Pairs`,
    review_your_peers_description: `Donnez des commentaires à vos pairs comme demandé.`,
    self_review: `Auto-Évaluation`,
    self_review_description: `Réfléchissez et soumettez votre auto-évaluation.`,
    react_to_received_reviews: `Réagir aux Avis Reçus`,
    react_to_received_reviews_description: `Marquez les commentaires reçus avec une réaction rapide.`,
    react: `Réagir`,
    react_guidance: `Reconnaissez les commentaires pour montrer que vous les avez lus et appréciés.`,
    set_a_goal: `Définir un Objectif`,
    set_a_goal_description: `Définissez un objectif basé sur les commentaires reçus.`,
    set_goal: `Définir l'Objectif`,
    review_goal_progress: `Examiner les Progrès de l'Objectif`,
    give_feedback: `Donner feedback`,
    check_your_progress: `Vérifier Vos Progrès`,
    view_detailed_report: `Voir le Rapport Détaillé`,
    check_progress_guidance: `Cliquez pour voir votre rapport de progrès détaillé dans la page Résumé.`,
    request_support: `Demander de l'Aide`,
    request_support_description: `Contactez votre manager, RH local ou champion pour clarifier les résultats et les prochaines étapes.`,
    request_support_guidance: `Obtenez de l'aide de vos contacts sélectionnés pour comprendre vos commentaires et planifier votre développement.`,
    your_support_requests: `Vos Demandes d'Aide`,
    created_on: `Créé le :`,
    completed: `Terminé`,
    open: `Ouvert`,
    request_support_dialog_title: `Demander de l'Aide`,
    request_support_dialog_tooltip: `Expliquez votre situation ou le type d'aide dont vous avez besoin. Les contacts sélectionnés recevront un e-mail.`,
    explain_your_request: `Expliquez Votre Demande`,
    add_request_placeholder: `Ajoutez votre demande ici...`,
    select_support_contacts: `Gérer les contacts de support (ajouter, supprimer ou modifier)`,
    manager_n1: `Manager N+1`,
    local_hr: `RH Local`,
    click_to_select_champion: `Cliquez pour sélectionner un nouveau champion`,
    search_user_placeholder: `Rechercher un utilisateur...`,
    add_your_manager: `Ajoutez votre Manager N+1`,
    add_your_local_hr: `Ajoutez votre RH Local`,
    you_dont_have_manager: `Vous n'avez pas de Manager N+1 assigné dans le système.`,
    you_dont_have_local_hr: `Vous n'avez pas de RH Local assigné dans le système.`,
    champion_conflict_error: `Votre champion associé ne peut pas être le même que le Manager N+1 ou le RH Local. Veuillez cliquer dans le champ de texte pour choisir quelqu'un d'autre.`,
    submit: `Soumettre`,
    cancel: `Annuler`,
    support_request_sent_success: `Demande d'aide envoyée avec succès 🎉`,
    support_request_send_failed: `Échec de l'envoi de la demande d'aide. Veuillez réessayer.`,
  },
  campaign_guide: {
    title: `Aperçu`,
    feedback_provider: `fournisseur de commentaires`,
    feedback_receiver: `destinataire de commentaires`,
    feedback_provider_receiver: `fournisseur et destinataire de commentaires`,
    step_of: `Étape {current} sur {total}`,
    active: `ACTIF`,
    closed: `FERMÉ`,
    date_range: `Du {start} au {end}`,
    step_titles: {
      select_reviewers_manager: `Étape 1 : Sélectionner l'Équipe`,
      select_reviewers_employee: `Étape 1 : Équipe de Feedback`,
      review_manager_employee: `Étape 2 : Donner et Recevoir`,
      review_manager: `Étape 2 : Donner et Recevoir`,
      review_employee: `Étape 2 : Donner feedback`,
      goal_manager: `Étape 3 : Définir un Objectif`,
      goal_employee: `Étape 3 : Examiner les Objectifs`,
      goal_progress_manager_employee: `Étape 4 : Examiner les Progrès`,
      goal_progress_manager: `Étape 4 : Examiner les Progrès`,
      goal_progress_employee: `Étape 4 : Commentaires sur les Progrès`,
      default: `Phase de Campagne`,
    },
    step_descriptions: {
      select_reviewers_manager: `En tant que manager, sélectionnez les membres de l'équipe qui fourniront des commentaires à vos collaborateurs directs.`,
      select_reviewers_employee: `Vous pourriez être sélectionné comme fournisseur de commentaires par l'un de vos managers ou pairs.`,
      review_manager_employee: `Complétez votre auto-évaluation, donnez des commentaires aux autres et examinez les commentaires reçus.`,
      review_manager: `Complétez votre auto-évaluation et examinez les commentaires reçus.`,
      review_employee: `Fournissez des commentaires pour votre manager ou vos pairs si demandé.`,
      goal_manager: `Définissez un objectif de développement basé sur les commentaires reçus.`,
      goal_employee: `Soutenez votre manager en examinant son objectif et ses actions.`,
      goal_progress_manager: `Réfléchissez sur vos progrès et mettez à jour votre équipe de feedback avec de nouveaux insights.`,
      goal_progress_employee: `Cliquez pour sélectionner le leader et fournir des commentaires`,
      default: `Les détails de cette phase apparaîtront ici.`,
    },
  },
  select_reviewers: {
    title: `Définir les fournisseurs de commentaires pour`,
    instruction: `Vous pouvez sélectionner jusqu'à 10 fournisseurs de commentaires dans la base de données (minimum 5 requis)`,
    guidance_title: `🧠 Pourquoi le Feedback 360° est Important`,
    guidance_1: `Les commentaires sont confidentiels et anonymes.`,
    guidance_2: `Mélangez les collaborateurs directs et les pairs pour une perspective plus large.`,
    guidance_3: `L'objectif est le développement, pas l'évaluation.`,
    guidance_4: `Cela aide les leaders à voir comment les autres les perçoivent — et à grandir.`,
    guidance_tooltip: `Cliquez pour plus d'informations sur la valeur du feedback 360°`,
    search_placeholder: `Cliquez pour rechercher un utilisateur existant`,
    submit_success: `L'équipe de feedback pour {{name}} a été soumise avec succès !`,
    submit_error: `L'envoi de l'équipe de feedback pour {{name}} a échoué. Réessayez !`,
    too_many_selected: `⚠️ Cet utilisateur a sélectionné {{count}} fournisseurs de commentaires. Veuillez en retirer {{excess}} !`,
    too_few_selected: `⚠️ Seulement {{count}} fournisseurs de commentaires sélectionnés. Veuillez en sélectionner au moins {{needed}} de plus !`,
    count_selected: `{{count}} fournisseurs de commentaires sélectionnés`,
  },
  user_card: {
    select_team: `Sélectionner l'Équipe`,
  },
  tooltips: {
    campaign_guide_info: `Guide pour chaque étape de campagne basé sur le type d'utilisateur.`,
    feedback_attention: `Vous avez des commentaires qui nécessitent votre attention.`,
    email_notification: `Après avoir soumis votre demande, vos contacts sélectionnés recevront une notification par e-mail.`,
    support_request: `Expliquez votre situation ou le type de support dont vous avez besoin. Les contacts sélectionnés recevront un e-mail.`,
    feedback_360_info: `Cliquez pour plus d'informations sur la valeur du feedback 360°`,
    self_review: `Auto-évaluation`,
    settings: `Paramètres`,
    reset: `Réinitialiser`,
    stretch_info: `Disponible uniquement sur les grandes résolutions > 1600px (xl)`,
  },
  buttons: {
    save_changes: `Enregistrer les Modifications`,
    create_user: `Créer un Utilisateur`,
    delete: `Supprimer`,
    deleting: `Suppression...`,
    cancel: `Annuler`,
    follow: `Suivre`,
    followed: `Suivi`,
    login: `Connexion`,
    verify: `Vérifier`,
    reset_password: `Réinitialiser le Mot de Passe`,
    forgot_password: `Mot de passe oublié ?`,
    sign_in: `Se connecter à Minimal`,
    manage_job: `Gérez le travail plus efficacement avec Minimal`,
    create_account: `Créer un compte`,
    send_request: `Envoyer la Demande`,
    update_password: `Mettre à Jour le Mot de Passe`,
    return_to_sign_in: `Retour à la connexion`,
    export_to_pdf: `+ Exporter en PDF`,
    continue: `Continuer`,
    view_detailed_report: `+ Voir le rapport détaillé`,
    view_ai_summary: `Voir le Résumé IA`,
    logout: `Déconnexion`,
    submit: `Soumettre`,
    finish: `Terminer`,
    next: `Suivant`,
    back: `Retour`,
    read_more: `Lire plus`,
    read_less: `Lire moins`,
    suggested: `Suggéré`,
    no_manager_or_peer: `Aucun Manager ou Collègue`,
  },
  forms: {
    public_profile: `Profil Public`,
    name: `Nom`,
    full_name: `Nom Complet`,
    email_address: `Adresse E-mail`,
    phone_number: `Numéro de Téléphone`,
    address: `Adresse`,
    country: `Pays`,
    state_region: `État/Région`,
    city: `Ville`,
    zip_code: `Code Postal`,
    about: `À Propos`,
    company: `Entreprise`,
    role: `Rôle`,
    first_name: `Prénom`,
    last_name: `Nom de famille`,
    password: `Mot de Passe`,
    old_password: `Ancien Mot de Passe`,
    new_password: `Nouveau Mot de Passe`,
    confirm_password: `Confirmer le Mot de Passe`,
    confirm_new_password: `Confirmer le Nouveau Mot de Passe`,
    email: `E-mail`,
    confirm_new_password_label: `Confirmer le Nouveau Mot de Passe`,
  },
  validation: {
    name_required: `Le nom est requis`,
    email_required: `L'e-mail est requis`,
    email_invalid: `L'e-mail doit être une adresse e-mail valide`,
    phone_required: `Le numéro de téléphone est requis`,
    country_required: `Le pays est requis`,
    address_required: `L'adresse est requise`,
    state_required: `L'état est requis`,
    city_required: `La ville est requise`,
    zip_required: `Le code postal est requis`,
    about_required: `À propos est requis`,
    company_required: `L'entreprise est requise`,
    role_required: `Le rôle est requis`,
    avatar_required: `L'avatar est requis`,
    password_required: `Le mot de passe est requis`,
    old_password_required: `L'ancien mot de passe est requis`,
    new_password_required: `Le nouveau mot de passe est requis`,
    confirm_password_required: `La confirmation du mot de passe est requise`,
    passwords_match: `Les mots de passe doivent correspondre`,
    password_min_length: `Le mot de passe doit contenir au moins 6 caractères`,
    password_number: `Le mot de passe doit contenir au moins un chiffre`,
    password_special: `Le mot de passe doit contenir au moins un caractère spécial`,
    first_name_required: `Le prénom est requis`,
    last_name_required: `Le nom de famille est requis`,
    code_required: `Le code est requis`,
  },
  auth: {
    sign_in: `Se connecter`,
    please_check_email: `Veuillez vérifier votre e-mail !`,
    email_confirmation_code: `Nous avons envoyé un code de confirmation à 6 chiffres à acb@domain, veuillez entrer le code dans la case ci-dessous pour vérifier votre e-mail.`,
    password_requirements: `Le mot de passe doit contenir :`,
    password_requirement_1: `Au moins 6 caractères`,
    password_requirement_2: `Inclut un chiffre (0–9)`,
    password_requirement_3: `Inclut un caractère spécial (ex. [!@#$%^&*(),.?":{}|<>])`,
    change_password_success: `Changement de mot de passe réussi !`,
    verify_success: `Vérification réussie !`,
    forgot_password_title: `Mot de passe oublié ?`,
    forgot_password_description: `Veuillez entrer l'adresse e-mail associée à votre compte et nous vous enverrons un lien par e-mail pour réinitialiser votre mot de passe.`,
    return_to_sign_in: `Retour à la connexion`,
  },
  admin: {
    users: `Utilisateurs`,
    organizational_chart: `Organigramme`,
    maintenance: `Maintenance`,
    workspace: `Espace de travail`,
    campaign: `Campagne`,
    campaign_details: `📊 Détails de la Campagne`,
    id: `🆔 ID`,
    start: `📅 Début`,
    end: `📅 Fin`,
    steps: `🧩 Étapes`,
    users_loaded: `Utilisateurs chargés`,
    clean_up_topics: `Nettoyer les Sujets`,
    survey_results: `📋 Résultats de l'Enquête`,
    reopen_incomplete_surveys: `Rouvrir les Enquêtes Incomplètes`,
    all: `Tous`,
    incomplete: `Incomplet`,
    not_submitted: `Non Soumis`,
    maintenance_function_performed: `Fonction de maintenance effectuée`,
    incomplete_surveys_reopened: `enquête(s) incomplète(s) rouverte(s)`,
    failed_to_reopen_surveys: `Échec de la réouverture des enquêtes`,
    send_welcome_email: `Envoyer l'E-mail de Bienvenue`,
    send: `Envoyer`,
    full_name: `Nom complet`,
    managers: `Managers`,
    peers: `Pairs`,
    local_hr: `RH Local`,
    ai_usage: `Usage IA`,
    ai_usage_title: `Usage de l'assistance IA`,
    ai_usage_subtitle: `Agrégats de l'espace de travail (aucun texte de commentaire stocké).`,
    ai_usage_period_day: `Jour`,
    ai_usage_period_week: `Semaine`,
    ai_usage_period_month: `Mois`,
    ai_usage_events: `Vérifications`,
    ai_usage_provider: `fournisseur`,
    ai_usage_local: `local uniquement`,
    ai_usage_tokens: `Jetons`,
    ai_usage_cost: `Coût est.`,
    ai_usage_estimated: `USD estimé`,
    ai_usage_users: `Utilisateurs`,
    ai_usage_unique_users: `Utilisateurs uniques avec activité IA`,
    ai_usage_latency: `Latence`,
    ai_usage_avg_latency: `Temps de réponse moyen`,
    ai_usage_flagged: `Signalés`,
    ai_usage_unavailable: `indisponible`,
    ai_usage_by_skill: `Par compétence`,
    ai_usage_updated: `Mis à jour {{time}}`,
    ai_usage_load_error: `Impossible de charger les métriques d'usage IA.`,
    ai_usage_by_surface: `Par surface`,
    ai_usage_empty: `Aucune donnée pour cette période.`,
    ai_usage_proposal_outcomes: `Réactions aux suggestions`,
    ai_usage_outcome_all: `Tous les résultats`,
    ai_usage_outcome_accepted: `Accepté (Mettre à jour)`,
    ai_usage_outcome_flagged_bad: `Signalé (désaccord)`,
    ai_usage_outcome_ignored: `Ignoré`,
    ai_usage_feature_all: `Toutes les surfaces`,
    ai_usage_feature_survey: `Commentaires enquête`,
    ai_usage_feature_goal: `Progression d'objectif`,
    ai_usage_feature_chat: `Chat`,
    ai_usage_feature_support: `Demandes de support`,
    ai_usage_feature_campaign_summary: `Résumé IA manager`,
    ai_usage_feature_other: `Autre`,
    ai_usage_feedback_title: `Revue des suggestions`,
    ai_usage_feedback_subtitle: `Brouillons et suggestions IA acceptées, ignorées ou signalées comme incorrectes.`,
    ai_usage_feedback_empty: `Aucun retour de suggestion pour ces filtres.`,
    ai_usage_filter_outcome: `Résultat`,
    ai_usage_filter_surface: `Surface`,
    ai_usage_draft: `Brouillon`,
    ai_usage_disagree_note: `Note de désaccord`,
    ai_usage_proposal: `Suggestion IA`,
    ai_usage_summary_excerpt: `Extrait du résumé`,
    ai_usage_campaign_disagree_badge: `Le manager n'est pas d'accord avec le résumé IA de campagne`,
    ai_usage_prev: `Précédent`,
    ai_usage_next: `Suivant`,
    ai_usage_users_title: `Utilisateurs par usage`,
    ai_usage_users_subtitle: `Principaux utilisateurs sur la période (paginé — adapté aux grands espaces).`,
    ai_usage_user_search: `Rechercher nom ou e-mail`,
    ai_usage_apply_filters: `Appliquer`,
    ai_usage_sort: `Trier`,
    ai_usage_sort_tokens_desc: `Plus de jetons`,
    ai_usage_sort_tokens_asc: `Moins de jetons`,
    ai_usage_sort_events_desc: `Plus de vérifications`,
    ai_usage_users_count: `{{count}} utilisateurs actifs`,
  },
  orgchart: {
    title: `Organigramme`,
    search_placeholder: `Rechercher un utilisateur par nom...`,
    workspace: `Espace de travail`,
    legend: `Légende :`,
    direct_reports: `Rapports directs`,
    peers: `Pairs`,
    top_level: `Niveau supérieur`,
    users: `utilisateurs`,
    no_users_found: `Aucun utilisateur trouvé`,
    employee: `Employé`,
    hr: `RH`,
    admin: `Admin`,
    manager: `Manager`,
    peer: `Pair`,
    showing_user_and_team: `Affichage :`,
    and_their_team: `et son équipe`,
    no_users_in_workspace: `Aucun utilisateur trouvé dans cet espace de travail.`,
    select_workspace: `Veuillez sélectionner un espace de travail pour voir l'organigramme.`,
    no_match_found: `Aucun utilisateur trouvé correspondant à votre recherche.`,
  },
  messages: {
    update_success: `Mise à jour réussie !`,
    verify_success: `Vérification réussie !`,
    delete_confirm: `Êtes-vous sûr de vouloir supprimer ?`,
    no_data: `Aucune Donnée`,
    survey_result_locked: `🔒 Résultats d'Enquête Verrouillés`,
    survey_result_locked_description: `Les résultats de l'enquête seront disponibles une fois que l'étape d'Examen de la campagne sera terminée.`,
    unable_to_logout: `Impossible de se déconnecter !`,
  },
  ui: {
    empty_content_alt: `contenu vide`,
    champion: `Champion`,
    date_created: `Date de création`,
  },
  hr_analytics: {
    general_analytics: `Analyses Générales`,
    accounts: `comptes`,
    reviews: `avis`,
    direct_reviews: `avis directs`,
    peer_reviews: `avis de pairs`,
    self_reviews: `auto-évaluations`,
    set_goal: `définir objectif`,
    completed_goal: `objectif terminé`,
    reviewer_selection_overview: `Aperçu de la Sélection des Évaluateurs`,
    update_teams: `Actualiser Équipes`,
      delete_selections: `Effacer Sélections`,
      delete_selections_tooltip: `Supprimer toutes les sélections d'évaluateurs pour la campagne sélectionnée. Cette action est irréversible !`,
      delete_selections_confirm_title: `Confirmer la Suppression des Sélections`,
      delete_selections_confirm_message: `Êtes-vous sûr de vouloir supprimer TOUTES les sélections d'évaluateurs pour cette campagne ? Cette action est IRRÉVERSIBLE et supprimera définitivement toutes les données de sélection.`,
      delete_selections_success: `Sélections d'évaluateurs supprimées avec succès !`,
      delete_selections_error: `Échec de la suppression des sélections d'évaluateurs. Veuillez réessayer.`,
      delete_reviews: `Supprimer les Avis`,
      delete_reviews_tooltip: `Supprimer tous les résultats de sondage, réponses, discussions et commentaires pour la campagne sélectionnée. Cette action est irréversible !`,
      delete_reviews_confirm_title: `Confirmer la Suppression des Avis`,
      delete_reviews_confirm_message: `Êtes-vous sûr de vouloir supprimer TOUS les résultats de sondage, réponses, discussions et commentaires pour cette campagne ? Cette action est IRRÉVERSIBLE et supprimera définitivement toutes les données.`,
      delete_reviews_success: `Avis supprimés avec succès !`,
      delete_reviews_error: `Échec de la suppression des avis. Veuillez réessayer.`,
      delete_goals: `Supprimer les Objectifs`,
      delete_goals_tooltip: `Supprimer tous les objectifs et buts pour l'espace de travail de la campagne sélectionnée. Cette action est irréversible !`,
      delete_goals_confirm_title: `Confirmer la Suppression des Objectifs`,
      delete_goals_confirm_message: `Êtes-vous sûr de vouloir supprimer TOUS les objectifs et buts pour cet espace de travail de campagne ? Cette action est IRRÉVERSIBLE et supprimera définitivement toutes les données.`,
      delete_goals_success: `Objectifs supprimés avec succès !`,
      delete_goals_error: `Échec de la suppression des objectifs. Veuillez réessayer.`,
      generate_demo_data: `Générer des Données de Démo`,
      generate_demo_data_tooltip: `Générer des résultats de sondage complétés avec des notes positives pour jusqu'à 8 managers. Inclut les rapports directs et les avis des pairs.`,
      generate_demo_confirm_title: `Générer des Données de Démo ?`,
      generate_demo_confirm_message: `Cela créera des résultats de sondage complétés avec des notes positives (3-5) et des scores de confiance/recommandation positifs pour jusqu'à 8 managers actifs dans cet espace de travail. Continuer ?`,
      generate_demo_success: `Données de démo générées avec succès ! {surveyResults} résultats de sondage créés avec {answers} réponses pour {managers} managers.`,
      generate_demo_error: `Échec de la génération des données de démo. Veuillez réessayer.`,
      generating: `Génération...`,
    managers_submitted_selections: `{submitted} sur {total} managers ont soumis leurs sélections d'évaluateurs.`,
    search_manager_by_name: `Rechercher un manager par nom`,
    submitted: `Soumis`,
    status: `Statut`,
    all_submitted: `✅ Tous Soumis`,
    partially_submitted: `⚠️ Partiellement Soumis`,
    no_submission: `❌ Aucune Soumission`,
    database_updated_successfully: `Base de données des managers et pairs mise à jour avec succès`,
    failed_to_update_reviewer_setup: `Échec de la mise à jour de la configuration des évaluateurs`,
    managers_reviews: `Managers - Avis`,
    managers_reached_completion: `{completed} sur {total} managers ont atteint 80% de completion des avis`,
    rank: `rang`,
    manager: `Manager`,
    percent_total_reviews: `% Total avis`,
    peer_reviews_ratio: `Ratio avis de pairs`,
    direct_reviews_ratio: `Ratio avis directs`,
    expand: `Développer`,
    ratings: `Notes`,
    rating: `Note`,
    trust: `Confiance`,
    recommend: `Recommander`,
    reviewers: `Évaluateurs`,
    no_reviewers_assigned: `Aucun évaluateur assigné.`,
    managers_goals: `Managers - Objectifs`,
    managers_set_goal: `{set} sur {total} managers ont défini un objectif.`,
    goal_set: `Objectif défini`,
    percent_goal_progress: `% Progrès objectif`,
    total_votes: `Total votes`,
    peer_votes_ratio: `Ratio votes de pairs`,
    direct_votes_ratio: `Ratio votes directs`,
    rating_label: `🎯 Note`,
    due_label: `📅 Échéance`,
    completed_on: `✅ Terminé le`,
    not_completed: `🕓 Non terminé`,
    actions: `Actions`,
    no_goals_available: `Aucun objectif disponible.`,
    support_requests_overview: `Aperçu des Demandes de Support`,
    total: `Total`,
    solved: `Résolu`,
    open: `Ouvert`,
    search_requester_by_name: `Rechercher un demandeur par nom`,
    status_header: `Statut`,
    requester: `Demandeur`,
    date: `Date`,
    comment: `Commentaire`,
    manager_header: `Manager`,
    local_hr: `RH Local`,
    champion: `Champion`,
    solved_date: `Date de Résolution`,
    solved_status: `Résolu`,
    open_status: `Ouvert`,
  },
  settings: {
    mode: `Mode`,
    contrast: `Contraste`,
    direction: `Direction`,
    layout: `Mise en Page`,
    stretch: `Étirer`,
    presets: `Prédéfinis`,
  },
  profile_sections: {
    social: `Social`,
    about: `À Propos`,
  },
  notifications: {
    activity_comments: `M'envoyer un e-mail quand quelqu'un commente mon article`,
    activity_answers: `M'envoyer un e-mail quand quelqu'un répond à mon formulaire`,
    activity_follows: `M'envoyer un e-mail quand quelqu'un me suit`,
    application_news: `Actualités et annonces`,
    application_product: `Mises à jour hebdomadaires du produit`,
    application_blog: `Résumé hebdomadaire du blog`,
  },
  categories: {
    vision: `VISION : envisage un avenir désiré et génère de l'enthousiasme en communiquant une vision partagée et convaincante`,
    communication: `COMMUNICATION : communique bien et fournit fréquemment des explications aux parties prenantes`,
    development: `DÉVELOPPEMENT : favorise une culture de développement en encourageant tous les membres de l'équipe à adopter un état d'esprit de croissance et à prendre des actions quotidiennes pour se développer et développer ceux qui les entourent`,
    trust: `CONFIANCE : influence les autres en construisant la crédibilité et des relations positives plutôt qu'en s'appuyant sur l'autorité pour générer de l'élan autour des priorités Shape`,
    problem_solving: `RÉSOLUTION DE PROBLÈMES : amélioration continue et utilisation de méthodologies éprouvées de résolution de problèmes`,
    care: `SOIN : capacité de mon manager à me prêter attention`,
    coach: `COACH : capacité de mon manager à me soutenir dans la mise en œuvre de solutions appropriées`,
    develop: `DÉVELOPPER : capacité de mon manager à révéler mon plein potentiel`,
    deliver: `LIVRER : capacité de mon manager à me guider dans l'atteinte de mes objectifs`,
    lead: `LEADER : capacité de mon manager à m'inspirer`,
  },
  campaign_progress: {
    title: "Progression de la Campagne",
    overall_progress: "Progression Globale",
    task_progress: "Progression des Tâches",
    completed: "Terminé",
    in_progress: "En Cours",
    detailed_progress: "Progression Détaillée",
    not_active: "Non Actif",
    progress_summary: "Statut",
    tasks_completed: "tâches terminées",
  },
    task_history: {
      title: "Historique des Tâches",
      completed_tasks: "Tâches Terminées",
      in_progress_tasks: "Tâches en Cours",
      completed: "Terminé",
      in_progress: "En Cours",
      summary: "Suivez votre progression de campagne et vos tâches terminées",
      recent_activity: "Activité Récente",
    },
  detailed_report: {
    title: `Rapport détaillé`,
    subtitle: `Notes par catégorie, commentaires et progression des objectifs pour cette campagne.`,
    global_score: `Score Global`,
    direct_reports: `Rapports Directs`,
    peer_reports: `Rapports de Pairs`,
    short_global: `Global`,
    short_team: `Équipe`,
    short_peers: `Pairs`,
    legend_label: `Scores`,
    legend_hint: `Les écarts ≥ 0,5 entre Équipe et Pairs sont mis en avant sur chaque question.`,
    show_comments: `Voir {n} commentaires`,
    hide_comments: `Masquer les commentaires`,
    goal_progress: `Progression des objectifs`,
    goal_progress_subtitle: `Votre objectif, actions et retours des reviewers.`,
    approval_rate: `Taux d'approbation`,
    total_votes: `Total`,
    action_items: `Objectif & actions`,
    comments_from_team: `Commentaires de votre équipe`,
    comments_from_peers: `Commentaires des pairs`,
    no_comments: `Pas encore de commentaires.`,
    no_goals: `Aucun objectif défini pour cette campagne.`,
    no_action_items: `Aucune action pour cet objectif.`,
    no_reviews_category: `Aucun avis disponible pour cette catégorie.`,
    goal_feedback: `Retours sur la progression`,
    no_goal_feedback_yet: `Aucun avis de progression soumis pour le moment.`,
  },
};

export default fr;
